import React from 'react';

import { NavLink, useLocation } from 'react-router-dom';
import {
  UnorderedListOutlined,
} from '@ant-design/icons';

import { Menu } from 'antd';

import type { MenuProps } from 'antd';

import { allowPermission } from 'utils/permission';
import MyIcon from '../SPCustomIcon';

type MenuItem = Required<MenuProps>['items'][number];

interface IComponentProps {
	permissionKey?: any;
	permission?: any;
  CollapseFn?: any
  collapsed?: boolean
}
const SPMenu: React.FC<IComponentProps> = props => {
	const { permission, CollapseFn, collapsed } = props;
	const location = useLocation()

	const getMenuItem = (
		label: React.ReactNode,
		key: React.Key,
		icon?: React.ReactNode,
		children?: MenuItem[],
		type?: 'group'
	): MenuItem => {
		if (!allowPermission(String(key), permission)) return null;

		return { key, icon, children, label, type } as MenuItem;
	};

	const menuItems: MenuItem[] = [
		getMenuItem(<NavLink to="/home">首页</NavLink>, '/home', <MyIcon type="i-home"></MyIcon>),
		getMenuItem('门店管理', 'storeManagement', <MyIcon type="i-store"></MyIcon>, [
			getMenuItem(
				<NavLink to="/storeManagement/Score">门店评分</NavLink>,
				'/storeManagement/Score',
			),
			getMenuItem(
				<NavLink to="/storeManagement/StoreList">门店列表</NavLink>,
				'/storeManagement/StoreList',
			),
			getMenuItem(<NavLink to="/storeManagement/RemoteReturn">门店异地还车</NavLink>, '/storeManagement/RemoteReturn'),
		]),
		getMenuItem('车辆管理', 'vehicleManagement', <MyIcon type="i-car"></MyIcon>, [
			getMenuItem(<NavLink to="/vehicleManagement/Vehicle">车辆列表</NavLink>, '/vehicleManagement/Vehicle'),
			getMenuItem(<NavLink to="/vehicleManagement/calendar">库存日历</NavLink>, '/vehicleManagement/calendar'),
			getMenuItem(<NavLink to="/vehicleManagement/Summary">库存汇总</NavLink>, '/vehicleManagement/Summary'),
		]),
		getMenuItem('商品及定价', 'product-price', <MyIcon type="i-price"></MyIcon>, [
			getMenuItem(<NavLink to="/product-price/car-model-price">车型商品定价</NavLink>, '/product-price/car-model-price'),
			getMenuItem(
				<NavLink to="/product-price/value-added-price">服务保障商品</NavLink>,
				'/product-price/value-added-price'
			),
			getMenuItem(
				<NavLink to="/product-price/booking-rule-template">预订规则模版</NavLink>,
				'/product-price/booking-rule-template'
			),
			getMenuItem(
				<NavLink to="/product-price/service-policy-template">服务政策模版</NavLink>,
				'/product-price/service-policy-template'
			),
			getMenuItem(
				<NavLink to="/product-price/cancel-rule-template">取消规则模版</NavLink>,
				'/product-price/cancel-rule-template'
			),
		]),
		getMenuItem('营销获客', 'active-management', <MyIcon type="i-market"></MyIcon>, [
			getMenuItem(<NavLink to="/actives/take-the-lead">搜索提升</NavLink>, '/actives/take-the-lead'),
			getMenuItem(<NavLink to="/actives/didi-section">精选栏目</NavLink>, '/actives/didi-section'),
			getMenuItem(<NavLink to="/actives/activity-list">活动列表</NavLink>, '/actives/activity-list'),
		]),
		getMenuItem('订单管理', 'order-management', <MyIcon type="i-order"></MyIcon>, [
			getMenuItem(<NavLink to="/order-management/order-list">订单列表</NavLink>, '/order-management/order-list'),
			// getMenuItem('订单来源配置', 'order-source-configuration'),
		]),
		getMenuItem('员工管理', 'employeeManagement', <MyIcon type="i-employee"></MyIcon>, [
			getMenuItem(<NavLink to="/employeeManagement/EmployeeList">员工列表</NavLink>, '/employeeManagement/EmployeeList'),
			getMenuItem(<NavLink to="/employeeManagement/RolePermissions">角色权限</NavLink>, '/employeeManagement/RolePermissions'),
		]),
		getMenuItem('通知管理', 'notification', <MyIcon type="i-notification"></MyIcon>, [
            getMenuItem(<NavLink to="/notification/notificationList">通知列表</NavLink>, '/notification/notificationList'),
			// todo：此处权限点需要确认
            getMenuItem(<NavLink to="/notification/csOrderList">工单列表</NavLink>, '/notification/csOrderList'),
		]),
		getMenuItem(<NavLink to="/supplier-entry">供应商入驻</NavLink>, 'supplierEntry', <MyIcon type="i-notification"></MyIcon>),
	];

	return <>
    <Menu defaultOpenKeys={location.pathname.split('/').slice(1, -1)} selectedKeys={[location.pathname]}  mode="inline" style={{ height: '100%' }} items={menuItems} />
    {
      permission?.length ? <Menu selectable={false} mode="inline"  style={{ position: 'sticky', bottom: '0px', width: '100%' }}>
        <Menu.Item
          onClick={() => CollapseFn()}
          style={{
            backgroundColor: 'transparent',
            color: 'inherit',
          }} icon={<UnorderedListOutlined />}>
          { collapsed ? "展开菜单" : '收起菜单' }
        </Menu.Item>
      </Menu> : null
    }
  </>

};

export default SPMenu;
